module.exports = __webpack_public_path__ + "static/media/20.a55c1af0.jpg";